import React from 'react';
import { Row, Col, Form, Input, Select, Button, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

interface AddressesFormSectionProps {
  t: any;
  addressTypeOptions?: { value: string; label: string }[];
  initialValues?: any[];
}

const DEFAULT_ADDRESS_TYPES = [
  { value: 'Property', label: 'Property Address' },
  { value: 'Billing', label: 'Billing Address' },
];

const AddressesFormSection: React.FC<AddressesFormSectionProps> = ({ t, addressTypeOptions, initialValues }) => (
  <Form.List
    name="addresses"
    initialValue={initialValues || []}
    rules={[{
      validator: async (_, addresses) => {
        if (!addresses || addresses.length < 1) {
          return Promise.reject(new Error(t('common:validation.atLeastOneAddress', 'At least one address is required')));
        }
        return Promise.resolve();
      }
    }]}
  >
    {(fields, { add, remove }) => (
      <>
        {fields.map(({ key, name, ...restField }) => (
          <Card
            key={key}
            style={{ marginBottom: 16 }}
            extra={
              fields.length > 1 && (
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => remove(name)}
                />
              )
            }
          >
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'type']}
                  label={t('common:type', 'Type')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Select>
                    {(addressTypeOptions || DEFAULT_ADDRESS_TYPES).map(opt => (
                      <Option key={opt.value} value={opt.value}>{t('sales:customers.addressType.'+opt.value, opt.label)}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'address']}
                  label={t('common:address')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  {...restField}
                  name={[name, 'city']}
                  label={t('common:city')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  {...restField}
                  name={[name, 'pincode']}
                  label={t('common:pincode')}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  {...restField}
                  name={[name, 'country']}
                  label={t('common:country')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        ))}
        <Form.Item>
          <Button
            type="dashed"
            onClick={() => add({ type: 'Property' })}
            block
            icon={<PlusOutlined />}
          >
            {t('common:addAddress', 'Add Address')}
          </Button>
        </Form.Item>
      </>
    )}
  </Form.List>
);

export default AddressesFormSection; 